import axios from 'axios'
import {getItem} from '@/helpers/persistanceStorage'
import {nameToken} from '@/helpers/vars'
import {baseUrl} from '@/api/base-url'
import vue$ from '@/main'
import {mutationTypes} from '@/store/modules/errors/erorrs'
import {includes} from 'ramda'

axios.defaults.baseURL = baseUrl

axios.interceptors.request.use((config) => {
  const token = getItem(nameToken)
  config.headers.Authorization = token ? `Bearer ${token}` : ''
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  return config
})

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const notAuthStatus =
      401 === error.response.status || 403 === error.response.status
    const isAuth = includes('auth', window.location.pathname)

    vue$.then((vue) => {
      if (notAuthStatus && !isAuth) {
        vue.$router.push({name: 'authLogin'})
      }
      if (!isAuth) {
        vue.$store.commit(mutationTypes.setErrors, error)
      }
    })
    return Promise.reject(error)
  }
)

export default axios
